import { range } from 'lodash'

export function xRange(to, numberOfPoints = 20) {
    return [...range(0, to, to / numberOfPoints), to]
}

export function applyFactor(factor, x) {
    if (typeof factor === 'function') return factor(x)
    if (typeof factor === 'number') return factor * x
    return x
}

export function scaleFactor(factor, alpha) {
    if (typeof factor === 'function') return (x => alpha * factor(x))
    return alpha * factor
}
export function inverseFactor(factor) {
    if (typeof factor === 'function') return (x => 1 / factor(x))
    return 1 / factor
}


export function performanceVsDeteriorationPoints(xPoints, curveParams) {
    const func = curveParams.m !== undefined ? enginePerformanceVsDeterioration : gearBoxAndWheelsPerformanceVsDeterioration
    return xPoints.map(x => ({ x, y: func(x, curveParams) }))
}

// export function performanceVsDeterioration(x, m = -10, threshold = 85) {
//     return Math.min(Math.max(m * (x - threshold), 0), 100)
// }

export function enginePerformanceVsDeterioration(D, curveParams) {
    // return performanceVsDeterioration(D, -10, 90)
    const { threshold, m } = curveParams
    if (D <= threshold) {
        return (m * D) + 1
    }
    const { a, b, c } = getCuadraticParams(m, threshold)
    return (a * D * D) + (b * D) + c
}

function getCuadraticParams(m, threshold) {
    const Y = 1 + (m * threshold)
    const a = -(Y + (m * (1 - threshold))) / ((threshold * threshold) - (2 * threshold) + 1)
    const b = m - (2 * a * threshold)
    const c = -a - b
    return { a, b, c, Y }
}

export function gearBoxAndWheelsPerformanceVsDeterioration(D, curveParams) {
    // return performanceVsDeterioration(D, -5, 95)
    const { performanceStartLevel: psl, minimumPerformanceLevel: mpl, startOfFastDecrease: sfd, takeoverTime: tot, curvinessParameter: cp } = curveParams
    return psl + ((mpl - psl) / (1 + Math.pow(cp, ((sfd + (tot / 2) - (D * 100)) / tot))))
}


export function performanceVsDeteriorationForDrivingStylePoints(xPoints, curveParams) {
    return xPoints.map(x => ({ x, y: performanceVsDeteriorationForDrivingStyle(x, curveParams) }))
}

export function wheelsPDet1(curveParams) {
    return gearBoxAndWheelsPerformanceVsDeterioration(1, curveParams)
}
export function performanceVsDeteriorationForDrivingStyle(performance, factor, pDet1) {
    return (factor * (performance - pDet1)) + pDet1
}



// WEBPACK FOOTER //
// src/utils/chartFunctions.js